import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { tokens } from '@everfi/design-system';
import { Layout } from '../../../core/components/Layout/component.js';
import { DragHandle } from './drag-handle.js';
import { CardSpecialLabel } from '../../CardComponents/card-special-label/component.js';
import { DismissAction } from './dismiss-action.js';
import { TextBox } from './text-box.js';
import { MediaBox } from './media-box.js';
import { ParentBox } from './parent-box.js';
import { CardActions } from './card-actions.js';

var NarrowHorizontalContainer = function NarrowHorizontalContainer(_ref) {
  var cardProps = _ref.cardProps,
      cardEffects = _ref.cardEffects;
  var isSortable = cardProps.isSortable,
      specialLabel = cardProps.specialLabel,
      dismissable = cardProps.dismissable,
      onDismiss = cardProps.onDismiss,
      mediaUrl = cardProps.mediaUrl,
      mediaContent = cardProps.mediaContent,
      parentLabel = cardProps.parentLabel;
  var hasMedia = cardEffects.hasMedia;
  return /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(DragHandle, {
    isSortable: isSortable
  }), specialLabel && /*#__PURE__*/React.createElement(CardSpecialLabel, _extends({}, specialLabel, {
    chakra: 'on'
  })), /*#__PURE__*/React.createElement(DismissAction, {
    dismissable: dismissable,
    onDismiss: onDismiss
  }), /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(TextBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }), (mediaUrl || mediaContent) && /*#__PURE__*/React.createElement(Layout, {
    margin: tokens.SpacingBaseMd,
    maxWidth: hasMedia ? '64px' : 'none'
  }, /*#__PURE__*/React.createElement(MediaBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }))), /*#__PURE__*/React.createElement(Layout, null, parentLabel && /*#__PURE__*/React.createElement(ParentBox, {
    cardProps: cardProps,
    cardEffects: cardEffects
  }), /*#__PURE__*/React.createElement(CardActions, {
    cardProps: cardProps
  })));
};

NarrowHorizontalContainer.displayName = "NarrowHorizontalContainer";
export { NarrowHorizontalContainer };